module.exports = __webpack_public_path__ + "html/custom-template-form.component.html";